import type { GridColDef, GridFilterItem, GridFilterOperator, GridRowModel } from "@mui/x-data-grid-premium";
import { gridRowSelectionIdsSelector } from "@mui/x-data-grid-premium";
import type { DimensionDictionary } from "../../../../../../../../../api/types/svTypes";

const COLUMN_INDEX_FOR_FILTERING = 0;

export interface TextFilterGridColumnsMeta {
  availableFields: string[];
  keyFieldName: string;
}

export const getTextFilterGridColumns = (meta: TextFilterGridColumnsMeta) => {
  return meta.availableFields.map((f, index) => {
    const column = {
      field: f,
      disableColumnMenu: true,
      flex: 1,
      disableReorder: true,
      valueFormatter: (value, _, col) => value ?? getFallbackValue(value, col.field === meta.keyFieldName),
    } as GridColDef;
    if (index === COLUMN_INDEX_FOR_FILTERING) {
      column.filterOperators = customFilterOperators;
      column.filterable = false;
    }
    return column;
  });
};

export const getTextFilterModel = (
  columns: GridColDef[],
  showOnlySelected: boolean,
  textFilter: string | undefined,
  availableFields: string[]
) => {
  return {
    items: [
      {
        field: columns[COLUMN_INDEX_FOR_FILTERING]?.field ?? "",
        operator: "customFilter",
        value: { showOnlySelected, textFilter, availableFields },
      },
    ],
  };
};

const getFallbackValue = (value: unknown, isKeyFieldColumn: boolean) => {
  if (isKeyFieldColumn) {
    return "No Value";
  }

  return value;
};

const isSatisfiesSearchFilter = (
  row: GridRowModel<DimensionDictionary>,
  searchFilter: string | undefined,
  availableFields: string[]
) => {
  if (!searchFilter) {
    return true;
  }
  const values = Object.entries(row)
    .filter(([key]) => availableFields.includes(key))
    .map(([, value]) => value as string);
  return values.some((value) => (value ?? "No Value").toLowerCase().includes(searchFilter.toLowerCase()));
};

const isSatisfiesSelectedFilter = (
  showOnlySelected: boolean | undefined,
  selectedRowIds: number[],
  row: GridRowModel<DimensionDictionary>
) => {
  if (!showOnlySelected) {
    return true;
  }
  return selectedRowIds.includes(row["id"] as number);
};

const customFilterOperators: GridFilterOperator[] = [
  {
    label: "Custom Filter",
    value: "customFilter",
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      const { showOnlySelected, textFilter, availableFields } = (filterItem.value ?? {
        availableFields: [],
      }) as {
        showOnlySelected?: boolean;
        textFilter?: string;
        availableFields: string[];
      };
      return (_value, row, _column, api) => {
        const asd = gridRowSelectionIdsSelector(api);
        const selectedRowIds = Array.from(asd.keys()) as number[];

        return (
          isSatisfiesSearchFilter(row, textFilter, availableFields) &&
          isSatisfiesSelectedFilter(showOnlySelected, selectedRowIds, row)
        );
      };
    },
  },
];
